import * as Normalize from '../normalize';
import * as Types from './types';

export const normalize = Normalize.normFn<Types.FilterObjSchema>(
  'filters',
  whole => whole
);

export const denormalize = Normalize.denormFn<Types.FilterObjSchema>(
  part => part
);
